import React, { useState, useEffect } from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import 'react-datepicker/dist/react-datepicker.css';
import { coursesApi } from '@/api/courses/coursesApi';
import { Button, notification, Table } from 'antd';
import { Link } from 'react-router-dom';
import { routesPath } from '@/utils/routesPath';
import { convertRoutePathToLink, isoDateStringToYYYYMMDD } from '@/utils/functions';
import { useTranslation } from 'react-i18next'; // Added import

const MySwal = withReactContent(Swal);
const URL = convertRoutePathToLink(routesPath.COURSES_ADMIN);

const ListComponent = ({ ...props }) => {
    const { t } = useTranslation(); // Added hook
    const [data, setData] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 10,
        total: 0
    });
    const getList = () => {
        coursesApi
            .getList({
                page: pagination.page,
                pageSize: pagination.pageSize
            })
            .then((res) => {
                setIsLoadingData(false);
                setData(res.data.data.rows);
                setPagination({ ...pagination, total: res.data.data.total });
            })
            .catch((err) => console.error(err));
    };
    useEffect(() => {
        getList();
    }, [pagination.page]);

    const handleDelete = (id) => {
        MySwal.fire({
            title: t('Course_Admin_List_Delete_Title'),
            text: t('Course_Admin_List_Delete_Text'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            confirmButtonText: t('Course_Admin_List_Delete_ConfirmButton'),
            cancelButtonText: t('Course_Admin_List_Delete_CancelButton'),
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                coursesApi.delete(id).then(() => {
                    notification.success({ message: t('Course_Admin_List_Delete_SuccessMessage') });
                    getList();
                });
            }
        });
    };

    const columns = [
        { key: 'title', dataIndex: 'title', title: t('Course_Admin_List_Table_Title') },
        {
            key: 'description',
            dataIndex: 'description',
            title: t('Course_Admin_List_Table_Description')
        },
        {
            key: 'startDate',
            dataIndex: 'startDate',
            title: t('Course_Admin_List_Table_StartDate'),
            render: (startDate) => isoDateStringToYYYYMMDD(startDate)
        },
        {
            key: 'endDate',
            dataIndex: 'endDate',
            title: t('Course_Admin_List_Table_EndDate'),
            render: (endDate) => isoDateStringToYYYYMMDD(endDate)
        },
        {
            key: 'action',
            dataIndex: 'action',
            title: t('Course_Admin_List_Table_Action'),
            render: (_, record) => {
                return (
                    <>
                        <Link to={URL + '/edit?id=' + record?.id}>
                            <button
                                type="button"
                                className="btn btn-icon btn-sm"
                                title={t('Course_Admin_List_Button_Edit')}>
                                <i className="fa fa-edit"></i>
                            </button>
                        </Link>
                        <button
                            onClick={() => handleDelete(record.id)}
                            type="button"
                            className="btn btn-icon btn-sm js-sweetalert"
                            title={t('Course_Admin_List_Button_Delete')}
                            data-type="confirm">
                            <i className="fa fa-trash-o text-danger"></i>
                        </button>
                    </>
                );
            }
        }
    ];

    return (
        <>
            <div className="section-body">
                <div className="container-fluid">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="header-action">
                            <h1 className="page-title">{t('Course_Admin_List_PageTitle')}</h1>
                            <ol className="breadcrumb page-breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="#">{t('Course_Admin_List_Breadcrumb_Brand')}</a>
                                </li>
                                <li
                                    className="breadcrumb-item active"
                                    aria-current="page">
                                    {t('Course_Admin_List_Breadcrumb_Active')}
                                </li>
                            </ol>
                        </div>
                        <Link to={URL + '/edit'}>
                            <Button
                                className=" !bg-[#0d356b] !text-white hover:!bg-[#A40000] hover:!text-white hover:!border-[#A40000]"
                                size="large">
                                {t('Course_Admin_List_Button_Create')}
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="section-body mt-4">
                <Table
                    loading={isLoadingData}
                    columns={columns}
                    dataSource={data}
                    pagination={{
                        pageSize: pagination.pageSize,
                        current: pagination.page,
                        total: pagination.total,
                        onChange: (e) => setPagination({ ...pagination, page: e })
                    }}
                />
            </div>
        </>
    );
};

ListComponent.displayName = 'List';

const List = (props) => {
    return (
        <ErrorWrapper>
            <ListComponent
                data-id="List-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default List;
